import React from 'react';
import PropTypes from 'prop-types';
import { alpha, Box, Grid } from '@mui/material';
import ThemeModeToggle from '../ThemeModeToggle';

const AuthSplitLayoutV2 = ({
  children,
  footer,
  showLogo = true,
  modeSetting,
  resolvedMode,
  onModeSettingChange,
}) => (
  <Grid container sx={{ minHeight: '100vh' }}>
    {modeSetting && resolvedMode && onModeSettingChange ? (
      <Box
        sx={{
          position: 'fixed',
          top: { xs: 12, sm: 16 },
          right: { xs: 12, sm: 16 },
          zIndex: theme => theme.zIndex.tooltip,
        }}
      >
        <ThemeModeToggle
          modeSetting={modeSetting}
          resolvedMode={resolvedMode}
          onModeSettingChange={onModeSettingChange}
        />
      </Box>
    ) : null}
    <Grid
      size={{ xs: 0, md: 6 }}
      sx={{
        display: { xs: 'none', md: 'block' },
        position: 'relative',
        backgroundImage: 'url(/images/homeNew.jpg)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
      }}
    >
      <Box
        sx={{
          position: 'absolute',
          inset: 0,
          bgcolor: theme => alpha(theme.palette.neutral[900], 0.32),
        }}
      />
    </Grid>

    <Grid
      size={{ xs: 12, md: 6 }}
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        bgcolor: 'background.default',
        py: { xs: 4, sm: 6 },
        px: { xs: 2, sm: 3 },
      }}
    >
      <Box sx={{ width: '100%', maxWidth: 420 }}>
        {showLogo ? (
          <Box
            component="img"
            src="/images/logos/logo.png"
            alt="Eletropontes"
            sx={{
              width: 260,
              maxWidth: '100%',
              mb: 3,
              mx: 'auto',
              display: 'block',
              objectFit: 'contain',
            }}
          />
        ) : null}

        {children}

        {footer ? <Box sx={{ mt: 4 }}>{footer}</Box> : null}
      </Box>
    </Grid>
  </Grid>
);

AuthSplitLayoutV2.propTypes = {
  children: PropTypes.node,
  footer: PropTypes.node,
  showLogo: PropTypes.bool,
  modeSetting: PropTypes.oneOf(['system', 'light', 'dark']),
  resolvedMode: PropTypes.oneOf(['light', 'dark']),
  onModeSettingChange: PropTypes.func,
};

export default AuthSplitLayoutV2;
